/**
 * webAdProvider — single source of truth for which WEB ad network is active.
 *
 * Set REACT_APP_WEB_AD_PROVIDER in /app/frontend/.env to pick the preferred
 * network:
 *   'ezoic'   (default) — Ezoic standalone display ads
 *   'adsense'           — Google AdSense (swap target; one env flip)
 *   'none'              — disable network ads entirely
 *
 * (Monetag was removed 2026-07 — it served adult/low-quality creatives; see
 * src/monetag.config.js which now only PURGES any legacy Monetag install.)
 *
 * The PREFERRED provider only renders once its real IDs are present. Until
 * then, activeWebAdProvider() returns 'house' so the simulated creatives keep
 * serving (fully testable today; auto-upgrades to real ads when configured).
 *
 * Mobile (iOS/Android) uses AppLovin MAX independently — see mobile/src/services/applovin.js.
 */
import { isEzoicConfigured, isEzoicBannerConfigured } from '../components/EzoicSlot';
import { isAdSenseConfigured } from '../components/AdSenseSlot';

const RAW = (process.env.REACT_APP_WEB_AD_PROVIDER || 'ezoic').toLowerCase();

export const WEB_AD_PROVIDER = ['ezoic', 'adsense', 'none'].includes(RAW) ? RAW : 'ezoic';

/**
 * Which provider should actually render right now for an interstitial:
 *   'ezoic' | 'adsense' | 'house' | 'none'
 */
export function activeWebAdProvider() {
  if (WEB_AD_PROVIDER === 'none') return 'none';
  if (WEB_AD_PROVIDER === 'ezoic' && isEzoicConfigured()) return 'ezoic';
  if (WEB_AD_PROVIDER === 'adsense' && isAdSenseConfigured()) return 'adsense';
  return 'house';
}

/**
 * Which provider should render for an inline banner. AdSense uses the same
 * responsive slot; Ezoic needs a distinct banner placeholder id.
 *   'ezoic' | 'adsense' | 'house' | 'none'
 */
export function activeBannerProvider() {
  if (WEB_AD_PROVIDER === 'none') return 'none';
  if (WEB_AD_PROVIDER === 'ezoic' && isEzoicBannerConfigured()) return 'ezoic';
  if (WEB_AD_PROVIDER === 'adsense' && isAdSenseConfigured()) return 'adsense';
  return 'house';
}
